import { useMemo } from "react";
import type { UIMessage } from "@ai-sdk/react";

export type CompactionStatus = "started" | "completed" | null;

export function useChatCompaction(
  messages: UIMessage[] | undefined,
): CompactionStatus {
  return useMemo(() => {
    if (!messages || messages.length === 0) return null;

    for (let i = messages.length - 1; i >= 0; i--) {
      const msg = messages[i]!;
      if (msg.role !== "assistant" || !msg.parts) continue;

      for (let j = msg.parts.length - 1; j >= 0; j--) {
        const part = msg.parts[j] as unknown as Record<string, unknown>;
        if (part?.type !== "data") continue;

        const data = part.data;
        if (!Array.isArray(data)) continue;

        for (const item of data) {
          if (
            typeof item === "object" &&
            item !== null &&
            (item as Record<string, unknown>).type === "compaction"
          ) {
            return (item as Record<string, unknown>).status as CompactionStatus;
          }
        }
      }
    }

    return null;
  }, [messages]);
}
